import { render, staticRenderFns } from "./index.vue?vue&type=template&id=74e339c0&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=74e339c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e339c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74e339c0')) {
      api.createRecord('74e339c0', component.options)
    } else {
      api.reload('74e339c0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=74e339c0&scoped=true", function () {
      api.rerender('74e339c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/brand/index.vue"
export default component.exports